<template>
  <div :style="{ ...styles }" class="tooltip">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: ["text", "styles"],
};
</script>
<style lang="less">
@import "../../assets/styles/variables";

.tooltip {
  min-width: 1.5rem;
  height: 1.5rem;
  font-size: 15px;
  text-align: center;
  border: 0.5px solid @kk-color-gray;
  background-color: white;
  position: absolute;
  transform: translate(0, -100%);
  z-index: 10;
}
</style>
